import React from "react";
import { useNavigate } from "react-router-dom";
import WidgetCard from "./card";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { Button } from "@ts-digital/vrc";
import { ANALYTICS_BASE_URL, TSDIGITAL_ENDPOINT } from "../../config";
import analyticsRender from "@tsanalytics/widget";

const WidgetRatingCompanies = () => {

  const navigate = useNavigate();
  const main = useSelector(state => state.main);
  const auth = useSelector(state => state.auth);

  const renderGraph = () => {

    const header = [
      {
        key: "Authorization",
        value: "Bearer " + auth.loginAuth.securityToken
      },
      {
        key: "X-App-Name",
        value: "DIGITALBOXWEB"
      },
      {
        key: "X-Manager-ID",
        value: main.accountantSelected
      },
      { key: "X-Item-ID",
        value: main.companySelected
      }
      ,
      { key: "X-User-ID",
        value: auth.loginAuth.id
      }
    ];

    const tsditigal_endpoint = TSDIGITAL_ENDPOINT?.replace("/#", "");
    const imagePathNoAuthGraph = `${tsditigal_endpoint}img/analyticsNoAuthGraph.svg`;

    const authType = "<div style=\"height:325px;padding:10px; background-size: contain; background-repeat: no-repeat;background-position: bottom center;background-image: url('" +imagePathNoAuthGraph + "');\"></div>";

    const noDataType = "<div style=\"height:325px;padding:10px; background-size: contain; background-repeat: no-repeat;background-position: bottom center;background-image: url('" +imagePathNoAuthGraph + "');\"></div>";
    try {
      analyticsRender({
        disableAnimation: true, // disabilita l'animazione nei grafici
        kpiName: "CheckUpRiepilogoDistribuzioneAziende", // nome del grafico da disegnare
        fiscalCode: main.accountantSelected, // id dell'azienda
        elementId: "ratingGraph", // l'id del div da disegnare
        backend: {
          baseUrl: ANALYTICS_BASE_URL, // url del nostro backend
          headers: header
        }
      },
      {
        // impostazioni di analytics
        showContainer: true,
        showFooter: false,
        showTitle: false,
        customSkin: {
          noData: noDataType,
          noAuth: authType
        }
      });
    } catch (e) {
      return null;
    }
    return undefined;
  };

  return (
    <WidgetCard
      type={"box2_3"}
      titleWidget={
        <div style={{display:"flex", justifyContent: "space-between"}}>
          <div><FormattedMessage id="checkup.ratingCompanies" /></div>
          <div><Button
            kind="secondary"
            onClick={() => {
              if (window.aptrinsic) {
                window.aptrinsic("track", "digital-box:CHECKUP-SHOW-RATING");
              }
              navigate("/companies-rating");
            }}>Guarda i rating</Button></div>
        </div>
      }
      customTitle={"noCapitalizeTitle"}
      footer={null}
    >
      <div style={{maxHeight: "300px"}}id = 'ratingGraph'>{renderGraph()}</div>
    </WidgetCard>
  );
};

export default WidgetRatingCompanies;
